import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/table/index.js
// module id = 903
// module chunks = 14